import Vue from "vue";
import VueI18n from "vue-i18n";
import zh from "@/i18n/langs/zh.js";
import en from "@/i18n/langs/en.js";
import de from "@/i18n/langs/de.js";

Vue.use(VueI18n); // 全局挂载

export const i18n = new VueI18n({
  locale: localStorage.getItem("tfl-lang") || "en", // 从localStorage中获取 默认中文
  messages: {
    zh, // 中文语言包
    en, // 英文语言包
    de, // 德文语言包
  },
});
export default i18n;



// WEBPACK FOOTER //
// ./src/i18n/index.js